import { createSafeActionClient } from "next-safe-action";

export const actionClient = createSafeActionClient({
  defaultValidationErrorsShape: "flattened",
  handleServerError(e, utils) {
    // You can access these properties inside the `utils` object.
    const { clientInput, metadata } = utils;

    // Log to console.
    console.error("Action error:", e.message, metadata, clientInput);

    // Return generic message
    return e.message;
  },
});
